import assertContainerElement from "Utils/assertContainerElement";
import initHeroAnimation from "./initHeroAnimation";
import "Styles/Pages/FlexibleOfficeSpaceLP.scss";
import { render } from "react-dom";
import WorkplaceSearchForm from "Pages/HP2/Components/WorkplaceSearchForm";
import React from "react";

initHeroAnimation();

// ---- search input ----
const searchFormRoot = document.getElementById("foslp-hero-search");
assertContainerElement(searchFormRoot);
render(<WorkplaceSearchForm />, searchFormRoot);